module.exports = __webpack_public_path__ + "img/empty-avatar-dark.0c3a4c8c.svg";